// @mui
import { IconButton, Tooltip } from '@mui/material'
// @mui/icons-material
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
//
import i18n from 'i18next'
import PropTypes from 'prop-types'
import * as React from 'react'

const FullscreenButton = (props) => {
  const { target, buttonProps, iconProps } = props
  //


  //
  // functions
  //
  const requestFullscreen = () => {
    const element = target || document.documentElement
    if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen() //Chrome15+, Safari5.1+, Opera15+
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen() //FF10+
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen() //IE11+
    } else if (element.requestFullscreen) {
      element.requestFullscreen() // HTML5 Fullscreen API仕様
    } else {
      alert('ご利用のブラウザはフルスクリーン操作に対応していません');
      return
    }
  }
  const exitFullscreen = () => {
    if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen(); //Chrome15+, Safari5.1+, Opera15+
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen(); //FF10+
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen(); //IE11+
    } else if(document.cancelFullScreen) {
      document.cancelFullScreen(); //Gecko:FullScreenAPI仕様
    } else if(document.exitFullscreen) {
      document.exitFullscreen(); // HTML5 Fullscreen API仕様
    }
  }
  const getFullscreenElement = () => {
    if (document.webkitFullscreenElement) {
      return document.webkitFullscreenElement;
    } else if (document.mozFullScreenElement) {
      return document.mozFullScreenElement;
    } else if (document.msFullscreenElement) {
      return document.msFullscreenElement;
    } else if (document.fullscreenElement) {
      return document.fullscreenElement;
    }
  }
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      requestFullscreen()
    } else {
      exitFullscreen()
    }
  }
  const handleToggleFullscreenOnClick = (evt) => {
    toggleFullscreen()
  }


  // main

  if (!document.fullscreenEnabled) return null

  let tooltip = i18n.t('toggle_fullscreen')
  let icon = <FullscreenIcon {...iconProps} />
  if (getFullscreenElement()) {
    // tooltip = i18n.t('exit_fullscreen')
    icon = <FullscreenExitIcon {...iconProps} />
  }

  return (
    <Tooltip arrow title={tooltip}>
      <IconButton
        onClick={handleToggleFullscreenOnClick}
        {...buttonProps}
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}
FullscreenButton.propTypes = {
  target: PropTypes.element,
  buttonProps: PropTypes.object,
  iconProps: PropTypes.object,
}
FullscreenButton.defaultProps = {
  target: null,
  buttonProps: {},
  iconProps: {},
}

export default FullscreenButton
